export default __webpack_public_path__ + "static/media/promotion-box-icon.59f7db1f.svg";